import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminLoginPage from "../pages/AdminLoginPage";
import AdminDashboardPage from "../pages/AdminDashboardPage";
import RequireAdminAuth from "./RequireAdminAuth";

const KaakaziniAdminApp = () => (
  <Router>
    <Routes>
      {/* Render login directly at root — no redirect, no /admin-login in the URL */}
      <Route path="/" element={<AdminLoginPage />} />

      {/* Keep this as an alias so direct links to /admin-login still work */}
      <Route path="/admin-login" element={<AdminLoginPage />} />

      <Route path="/admin-dashboard" element={
        <RequireAdminAuth>
          <AdminDashboardPage />
        </RequireAdminAuth>
      } />

      {/* Fallback: send unknown paths to root, not to /admin-login */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>
);

export default KaakaziniAdminApp;